import React from 'react';
import PropTypes from 'prop-types';
import SelectDropdown from "../../Components/Dropdowns/SelectDropdown";
import iconCheck from "../../../assets/check.svg";

export const SUMMARIZED_MULTI_SELECT_TEST_ID = "summarized-multi-select-container";
export const SELECTION_SUMMARY_TEST_ID = "summarized-multi-select-summary";

export const selectionSummaryText = (selectedCount, totalCount, summaryNoun) =>
    `${selectedCount} of ${totalCount} ${summaryNoun}`;

const SelectionSummary = ({index, getValue, selectProps}) => {
    if (index > 0) return null;

    const selected = getValue();
    const summary = selected.length === 1
        ? selected[0].label
        : selectionSummaryText(selected.length, selectProps.options?.length ?? selected.length, selectProps.summaryNoun);

    return <span className={'summarized-multi-select-summary'}
                 data-testid={SELECTION_SUMMARY_TEST_ID}
                 title={selected.map(option => option.label).join(', ')}>
        {summary}
    </span>;
};

const checkableOptionStyles = {
    option: (base, state) => ({
        ...base,
        backgroundColor: state.isFocused ? '#DEEBFF' : '#FFF',
        color: '#0a0a0a',
    }),
};

const optionLabelWithSelectedCheck = (option, {context, selectValue}) => {
    if (context !== 'menu') return option.label;

    const isSelected = selectValue.some(selected => selected.value === option.value);
    return <div className={`summarized-multi-select-option ${isSelected ? 'is-selected' : ''}`}>
        <span>{option.label}</span>
        {isSelected && <img alt={'selected'} src={iconCheck} data-testid={`${option.label}-selected`}/>}
    </div>;
};

const SummarizedMultiSelect = ({
                                   id,
                                   className = "optional-dropdown",
                                   dataTestId = SUMMARIZED_MULTI_SELECT_TEST_ID,
                                   inputLabel,
                                   options,
                                   selectValues = undefined,
                                   onChange,
                                   placeholder = 'Select...',
                                   summaryNoun
                               }) => (
    <SelectDropdown id={id}
                    className={className}
                    dataTestId={dataTestId}
                    inputLabel={inputLabel}
                    isMulti
                    isClearable
                    options={options}
                    selectValues={selectValues}
                    onChange={onChange}
                    placeholder={placeholder}
                    summaryNoun={summaryNoun}
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    formatOptionLabel={optionLabelWithSelectedCheck}
                    components={{MultiValue: SelectionSummary}}
                    styles={checkableOptionStyles}
    />
);

SummarizedMultiSelect.propTypes = {
    id: PropTypes.string.isRequired,
    className: PropTypes.string,
    dataTestId: PropTypes.string,
    inputLabel: PropTypes.string,
    options: PropTypes.array,
    selectValues: PropTypes.array,
    onChange: PropTypes.func,
    placeholder: PropTypes.string,
    summaryNoun: PropTypes.string.isRequired,
};

export default SummarizedMultiSelect;
